import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import './RecordStyledTableBody.css';
import HighlightKeywordCell from  '../../FunctionArea/HighlightKeywordCell'

const useStyles = makeStyles({
    StyledBody: {
    },
    StyledRow: {
        cursor:"pointer"
    },
    StyledCell:{
        color:"black",
        fontFamily:"Microsoft JhengHei",
        fontSize:12
    },
    mountBottom:{
        width:"50px",
        backgroundColor:"#a7fafa",
        color:"black",
        border:"1px solid",
        borderRadius:"5px",
        textAlign:"center",
        cursor:"pointer",
        '&:hover':{
            backgroundColor:"#c9ffff",
        },
    },
    unmountBottom:{
        width:"50px",
        backgroundColor:"#a2b8b8",
        color:"black",
        border:"1px solid",
        borderRadius:"5px",
        textAlign:"center",
        cursor:"pointer",
        '&:hover':{
            backgroundColor:"#c9ffff",
        },
    },

  });

function CellGroup(props) {
    const classes = useStyles();

    let result
    if(props.status)
    {
        let temp = []
        props.status.forEach(element => {
            if(element.status)
            {
                temp.push(element)
            }
        });

        result = temp.map((column,index)=>{
            return  <TableCell className={classes.StyledCell} key={index} align="left"><HighlightKeywordCell text={props.row[column.columnName]} keywords={props.keywords}/></TableCell>
        })
    }
    else
    {
        result = null
    }

    return result
}


const ToggleBottom =({mountToggle,sysID,toggleMovieMount})=> {
    const handlerClick =(e,mountToggle)=>{
        e.preventDefault()
        e.stopPropagation()
        let msg = {
            Movie_SysID:sysID,
            Movie_Mount:mountToggle === 0 ? 1:0
        }
        //console.log("toggleMovieMount clicked!", msg)
        toggleMovieMount(msg)
    }
    const classes = useStyles();
    return  <div className={mountToggle === 0 ? classes.mountBottom:classes.unmountBottom} onClick={(e)=>handlerClick(e,mountToggle,sysID)}>{mountToggle === 0 ?"上架":"下架"}</div>
}
  

const RecordStyledTableBody =(props)=> {
    const classes = useStyles();
    //let index = 1

    const handlerClick =(msg)=>{
        props.toggleMovieMount(msg)
    }

    const getIndex=(index)=>{
        if(props.limitNumber && props.pageNumber)
        {
            let output = props.limitNumber * (props.pageNumber-1) + 1 + index
            return output
        } 
        else
        {
            return 0
        }
    }

    return (
        <TableBody className={classes.StyledBody}>
            {
                props.listData.map((row,index)=>(
                    <TableRow hover className={classes.StyledRow} key={row.Movie_SysID} onClick={()=>props.handleRecordListClicked(row.Movie_SysID)}>
                        <TableCell className={classes.StyledCell} align="left">{getIndex(index)}</TableCell>
                        <TableCell className={classes.StyledCell} align="left"><HighlightKeywordCell text={row.Movie_SysID} keywords={props.keywords}/></TableCell>
                        <TableCell className={classes.StyledCell} align="left"><HighlightKeywordCell text={row.Movie_TitleMain} keywords={props.keywords}/></TableCell>
                        <CellGroup row={row} status={props.columnStatus} keywords={props.keywords}/>         
                        <TableCell className={classes.StyledCell} align="left"><ToggleBottom mountToggle={row.Movie_Mount} sysID={row.Movie_SysID} toggleMovieMount={handlerClick}/></TableCell>            
                    </TableRow>
                ))
            }
        </TableBody>
    )
}

export default RecordStyledTableBody